<script lang="ts">
    
    import { onDestroy } from "svelte";

    export let src: string;
    export let volume = 0.25;

    let objectUrl: Promise<string>;

    $: objectUrl = updateBlob(src);

    onDestroy(revokeObjectURL);

    async function updateBlob(src: string): Promise<string> {
        try {
            await revokeObjectURL();
            const response = await fetch(src);
            if (!response.ok) {
                throw new Error(`Ha ocurrido un error al obtener el audio "${src}"`);
            }
            return URL.createObjectURL(await response.blob());
        } catch (error) {
            console.log(error);
        }
    }

    export async function play(): Promise<void> {
        if (!objectUrl || !window.document.hasFocus()) {
            return;
        }
        const audio = document.createElement('audio') as HTMLAudioElement;
        audio.src = await objectUrl;
        audio.volume = volume;
        audio.addEventListener('ended', () => audio.remove());
        audio.addEventListener('error', () => audio.remove());
        document.body.append(audio);
        await audio.play();
    }

    async function revokeObjectURL(): Promise<void> {
        if (!objectUrl) {
            return;
        }
        URL.revokeObjectURL(await objectUrl);
    }

</script>
